// extracted by mini-css-extract-plugin
module.exports = {"SNA8":"SNA2c_SNA8__16FtA","KneeContainer":"SNA2c_KneeContainer__2GTH1"};